<template>
  <div class="article">
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <span class="pointer" @click="toHome">首页</span>
          <span>>></span>
          <span class="pointer" @click="toPath('/shisanwu')">十三五</span>
          <span>>></span>
          <span>成就展</span>
        </div>
      </div>
    </div>

    <div class="content-box">
      <component :is="componentName" />
    </div>
  </div>
</template>

<script>
import TextContent from './components/TextContent'
import ChartContent from './components/ChartContent'
import VideoContent from './components/VideoContent'
import ImageContent from './components/ImageContent'
import VRContent from './components/VRContent'
import ImageVideoContent from './components/ImageVideoContent'
import ImageVRContent from './components/ImageVRContent'
import ImageVideoVRContent from './components/ImageVideoVR'
export default {
  components: {
    ChartContent,
    TextContent,
    VideoContent,
    ImageContent,
    VRContent,
    ImageVideoContent,
    ImageVRContent,
    ImageVideoVRContent
  },
  data () {
    return {
      // 0/文字 1/图表 2/视频 3/图片 4/VR 5/图片+视频 6/图片+VR 7/图片+视频+VR
      type: 0
    }
  },
  computed: {
    componentName () {
      const list = ['TextContent', 'ChartContent', 'VideoContent', 'ImageContent', 'VRContent', 'ImageVideoContent', 'ImageVRContent', 'ImageVideoVRContent']
      return list[this.type] || ''
    }
  },
  mounted () {
    const type = this.$route.query.type
    this.type = type || 0
    console.log(this.$route.matched)
  },
  methods: {
    toHome () {
      this.$router.push('/')
    },
    toPath (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
}
.content-box {
  width: 1160px;
  margin: 0 auto;
}
.pointer {
  cursor: pointer;
  &:hover {
    color: rgba(19, 107, 174, 1)!important;
    border-color: rgba(19, 107, 174, 1)!important;
  }
}

.article {
  .breadcrumb-box {
    margin-bottom: 24px;
    padding-top: 12px;
    .breadcrumb-body {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;
      span {
        margin-right: 7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/article/index.vue